import clsx from 'clsx'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'

interface Props {
  className?: string
  primaryHeadline: string
  subText: string
  primaryCta?: StrapiLinkSharedComponent | null
  image?: {
    url: string
    alternativeText: string
    height: number
    width: number
  }
}

function GetStarted({
  className,
  primaryHeadline,
  subText,
  primaryCta,
  image
}: Props) {
  return (
    <section className={clsx(className, `text-white`)}>
      <div className="container | grid gap-8 md:grid-cols-2 items-center | py-10">
        {image ? (
          <Image
            src={image.url}
            alt={image.alternativeText}
            width={image.width}
            height={image.height}
            className="hidden md:block | max-w-col-5 w-full | mx-auto "
          />
        ) : null}

        <div className="max-w-md | mx-auto">
          <h2
            className="font-heading text-2xl md:text-4xl font-medium text-center md:text-left | mb-3 md:mb-5"
            dangerouslySetInnerHTML={{ __html: primaryHeadline }}
          />
          <div
            className="text-base md:text-xl font-semibold text-center md:text-left | mb-5 lg:mb-8"
            dangerouslySetInnerHTML={{ __html: subText }}
          />
          {image ? (
            <Image
              src={image.url}
              alt={image.alternativeText}
              width={image.width}
              height={image.height}
              className="md:hidden | max-w-col-5 w-full | mx-auto mb-5"
            />
          ) : null}
          {primaryCta ? (
            <div className="flex justify-center md:justify-start">
              <Link
                href={primaryCta.href}
                className="text-lg md:text-xl text-blue-web-90 font-medium | max-w-col-4 w-full px-2 | new-btn-tertiary bg-yellow-40"
              >
                {primaryCta.title}
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}

export default GetStarted
